import React from 'react'

const Manual_ordenes_de_compra_crear_orden_de_compra = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
     <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
     Órdenes de Compra - Crear Orden de Compra
     </h2>
     <p className="text-lg text-gray-700 mb-6">
     Esta guía detalla un proceso paso a paso para crear y gestionar órdenes de
compra, asegurando eficiencia y precisión en la gestión del inventario. Cubre
desde la selección de proveedores hasta la entrada de detalles del producto y la
verificación de totales, siendo esencial para quienes participan en compras. Al
seguir esta guía, los usuarios pueden optimizar su flujo de trabajo, reducir errores
y mantener registros claros, mejorando la eficacia operativa
     </p>
     <iframe
          src="https://scribehow.com/embed/Ordenes_de_Compra__Crear_Orden_de_Compra__oyIggWrGRA-Xjm36O_WwKg?as=scrollable"
          className="scribe-iframe-general-5"
          width="100%"
          height="9200"
          allowFullScreen
          style={{
            aspectRatio: '1 / 1',
            border: 0,
            minHeight: '480px'
          }}
        ></iframe>
   </div>
   </div>
  )
}

export default Manual_ordenes_de_compra_crear_orden_de_compra